import React from 'react';

const DashboardRecentActivity = () => {
  const activities = [
    { id: 1, name: 'Max', type: 'Check-in', time: 'Hace 10 min', img: 'https://images.unsplash.com/photo-1583511655826-05700d52f4d9?w=200' },
    { id: 2, name: 'Bella', type: 'Paseo', time: 'Hace 25 min', img: 'https://images.unsplash.com/photo-1583512603805-3cc6b41f3edb?w=200' },
    { id: 3, name: 'Rocky', type: 'Baño', time: 'Hace 1 hora', img: 'https://images.unsplash.com/photo-1537151625747-768eb6cf92b2?w=200' },
    { id: 4, name: 'Luna', type: 'Check-out', time: 'Hace 2 horas', img: 'https://images.unsplash.com/photo-1561037404-61cd46aa615b?w=200' }
  ];

  return (
    <div className="ml-64 p-6">
      <div className="bg-white rounded-xl shadow-sm p-6">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-lg font-semibold text-gray-800">Actividad reciente</h3>
          <button className="text-sm text-cyan-600 hover:text-cyan-700">Ver todo</button>
        </div>
        <div className="space-y-4">
          {activities.map((activity) => (
            <div key={activity.id} className="flex items-center">
              <div className="h-10 w-10 rounded-full bg-cyan-50 overflow-hidden mr-4">
                <img src={activity.img} alt={activity.name} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1">
                <p className="font-medium text-gray-800">{activity.name}</p>
                <p className="text-sm text-gray-500">{activity.type}</p>
              </div>
              <span className="text-sm text-gray-400">{activity.time}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardRecentActivity;

// DONE